import {
  Box,
  Button,
  Divider,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import InputMask from "react-input-mask";
import AddIcon from "@material-ui/icons/Add";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { actions } from "../../../../redux/actions/alert";
import { MovileService } from "../../../../services/movile.service";
import styles from "../../../../styles/global-styles";

const usetSyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  label: {
    marginBottom: "1.5vh",
  },
  backgroundIcon: styles.backgroundIcon,
  box: {
    marginTop: "30px",
  },
}));

const CreateImeiForm = ({
  addAlert,
  detailAlert,
  detailProduct,
  productsCreated,
  isNewStock,
}) => {
  const [imeiInputs, setImeiInputs] = React.useState("");
  const [bulkMoviles, setBulkMoviles] = React.useState([]);
  const [imeiArray, setImeiArray] = React.useState([{}]);
  const [showImeiInputs, setShowImeiInputs] = React.useState(false);

  const classes = usetSyles();

  useEffect(() => {
    (async function fetchData() {
      if (bulkMoviles.length > 0) {
        try {
          const imeisAdded = await MovileService.updateBulkMoviles(bulkMoviles);
          console.log("imeisAdded", imeisAdded);
          if (imeisAdded && imeisAdded.status === 201) {
            productsCreated(true, "Stock dado de alta exitosamente", "created");
          }
        } catch (error) {
          console.log("error bulk moviles", error);
          addAlert({ showAlert: true });
          detailAlert({ severity: "error", message: error.msgs });
          productsCreated(false, error, "created");
        }
      }
    })();
  }, [bulkMoviles]);

  const createImeiInputsDynamically = () => {
    let copyArray = [...imeiArray];
    copyArray.length = imeiInputs;
    for (let i = 0; i < imeiInputs; i++) {
      copyArray[i] = {};
      setImeiArray(copyArray);
    }
    setShowImeiInputs(true);
  };

  const buildImeiInputs = () => {
    let tmpArray = [];
    for (let i = 0; i < imeiInputs; i++) {
      tmpArray.push("");
    }
    return tmpArray.map((v, i) => {
      return (
        <Grid key={i} item sm={6} md={6} lg={4} xl={4}>
          <Box className={classes.box}>
            <InputMask
              mask="999999999999999"
              maskChar=""
              value={imeiArray[i].imeiCode || ""}
              onChange={(e) => handleImeiInput(e, i)}
            >
              {() => (
                <TextValidator
                  className={classes.inputField}
                  name="imeiCode"
                  placeholder="Imei"
                  validators={["required"]}
                  errorMessages={["El IMEI es requerido"]}
                  variant="outlined"
                ></TextValidator>
              )}
            </InputMask>
          </Box>
        </Grid>
      );
    });
  };

  const hasDuplicates = (array) => {
    let valuesSoFar = Object.create(null);
    for (var i = 0; i < array.length; ++i) {
      var value = array[i];
      if (value.imeiCode in valuesSoFar) {
        return true;
      }
      valuesSoFar[value.imeiCode] = true;
    }
    return false;
  };

  const addImeisToMovile = async () => {
    addAlert({ showAlert: false });
    /**recover id for udpate first movile creation */
    const id = detailProduct.movileId;
    console.log("detailProduct", detailProduct);
    if (hasDuplicates(imeiArray)) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message: "El IMEI no puede estar repetido, verificar campos",
      });
      return;
    }

    const copyBulkMoviles = [...bulkMoviles];
    delete detailProduct.movileId;
    imeiArray.forEach((imei, i) => {
      detailProduct.imeiCode = imei.imeiCode;
      /** Create product in Almacen */
      detailProduct.siteId = 1;
      // VALIDATE
      detailProduct.inDistribution = 0;
      copyBulkMoviles[i] = { ...copyBulkMoviles[i], ...detailProduct };
    });

    console.log("copyBulkMoviles BEFORE", copyBulkMoviles);
    if (!isNewStock) copyBulkMoviles[0] = { ...copyBulkMoviles[0], id };
    console.log("copyBulkMoviles AFTER", copyBulkMoviles);
    setBulkMoviles(copyBulkMoviles);
  };

  const handleImeiInput = (e, index) => {
    let copyArray = [...imeiArray];
    const value = { [e.target.name]: e.target.value };
    copyArray[index] = { ...copyArray[index], ...value };
    setImeiArray(copyArray);
  };

  return (
    <React.Fragment>
      <div>
        <ValidatorForm
          noValidate
          onKeyPress={(event) => {
            if (event.which === 13 /* Enter */) {
              event.preventDefault();
            }
          }}
          className={classes.form}
          method="POST"
          onSubmit={createImeiInputsDynamically}
        >
          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="center"
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              style={{ marginTop: "30px" }}
            >
              <Typography
                variant="body2"
                component={"div"}
                className={classes.label}
              >
                Agregar IMEIs
              </Typography>
              <InputMask
                mask="99"
                maskChar=""
                value={imeiInputs}
                onChange={(e) => {
                  if (e.target.value === "") {
                    setShowImeiInputs(false);
                  }
                  setImeiInputs(parseInt(e.target.value));
                }}
              >
                {() => (
                  <TextValidator
                    name="model"
                    variant="outlined"
                    validators={["required"]}
                    errorMessages={["Es necesario agregar un número"]}
                    inputProps={{
                      maxLength: 15,
                    }}
                  ></TextValidator>
                )}
              </InputMask>
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                style={{ marginTop: "20px" }}
                type="submit"
                endIcon={
                  <AddIcon className={classes.backgroundIcon} color="primary" />
                }
              >
                Crear campos
              </Button>
            </Grid>
          </Grid>
        </ValidatorForm>
      </div>
      <Divider style={{ marginTop: 30 }} />

      <ValidatorForm
        noValidate
        onKeyPress={(event) => {
          if (event.which === 13 /* Enter */) {
            event.preventDefault();
          }
        }}
        className={classes.form}
        method="POST"
        onSubmit={addImeisToMovile}
        onError={(errors) => console.log(errors)}
      >
        <Grid
          style={{ marginTop: 30 }}
          container
          direction="row"
          justify="space-around"
          alignItems="center"
        >
          {showImeiInputs && buildImeiInputs()}
          {showImeiInputs && (
            <Grid item xs={12}>
              <Button
                color="primary"
                style={{ width: 150, marginTop: "20px" }}
                variant="contained"
                type="submit"
                endIcon={
                  <ArrowRightAltIcon
                    className={classes.backgroundIcon}
                    color="primary"
                  />
                }
              >
                Continuar
              </Button>
            </Grid>
          )}
        </Grid>
      </ValidatorForm>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(CreateImeiForm);
